import { wsClient, WsRecvType, IWsHandler } from '../client'
import { toast } from 'react-toastify'

type IMessageData = {
    type: 'info' | 'warn' | 'success' | 'error'
    message: string
}

type IMessageHandler = IWsHandler<IMessageData>

export default function () {
    wsClient.submitHandler(WsRecvType.Message, (({ data }) => {
        console.log(`%c[WsClient][${new Date().toISOString()}] Message`, 'color: red', data!.message)
        toast[data!.type](data!.message)
    }) as IMessageHandler)
}
